import { DataTable, List } from "@/components/admin"

const PermissionList: React.FC = () => {
  return (
    <List sort={{ field: "user_id", order: "ASC" }}>
      <DataTable.Col source="resource" label="Ressource" />
      <DataTable.Col source="action" label="Action" />
    </List>
  )
}

export default PermissionList
